import { RESALE_SETTINGS_FULLY_VISIBLE, ResaleSettingsVisibility } from '@domain/resale-settings';

/**
 * No payload shows every block, so shipping this changed nothing until someone edited the flag. Once there is
 * a payload, a block shows only when its key is the literal `true`: a missing key, a typo or a quoted "true"
 * hides it, so a slip in PostHog can hide a finished block but never expose an unfinished one.
 *
 * `unknown` because PostHog hands back whatever JSON was typed in, whatever `FeatureFlagPayloadMap` says.
 */
export const toResaleSettingsVisibility = (payload: unknown): ResaleSettingsVisibility => {
  if (payload === undefined || payload === null) return RESALE_SETTINGS_FULLY_VISIBLE;
  const keys: Record<string, unknown> =
    typeof payload === 'object' && !Array.isArray(payload) ? (payload as Record<string, unknown>) : {};
  return {
    activationMode: keys.activation_mode === true,
    organizerFee: keys.organizer_fee === true,
    timeSettings: keys.time_settings === true,
  };
};
